import { createTheme } from '@mui/material';

import { colors } from 'config/theme';
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#005ea2',
      light: '#73b3e7',
      dark: '#28A0CB',
    },
    secondary: {
      main: '#7852A9',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350,',
      contrastText: '#fff',
    },
    success: {
      main: '#00A91C',
      light: '#70E17B',
      dark: '#4D8055',
    },
    warning: {
      main: '#C05600',
    },
  },
  typography: {
    fontSize: 12,
    body1: {
      fontSize: '1rem',
    },
    subtitle1: {
      color: colors.darkGray,
      fontSize: '.8rem',
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '.85rem',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#263238',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          whiteSpace: 'pre-wrap',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: `solid 1px ${colors.uswds.base.lightest}`,
        },
      },
    },
  },
});
